<template>
  <ResponsiveNitroPayAd v-if="!showClouDNSAds() || !showClouDNS" :config="config" />
  <div v-else class="w-fit mx-auto">
    <ClouDNSAd class="sm:hidden" :sizes="getSizes('default')" />
    <ClouDNSAd class="hidden sm:block md:hidden" :sizes="getSizes('sm')" />
    <ClouDNSAd class="hidden md:block lg:hidden" :sizes="getSizes('md')" />
    <ClouDNSAd class="hidden lg:block xl:hidden" :sizes="getSizes('lg')" />
    <ClouDNSAd class="hidden xl:block 2xl:hidden" :sizes="getSizes('xl')" />
    <ClouDNSAd class="hidden 2xl:block" :sizes="getSizes('2xl')" />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { AdUnit } from '@/common/adSlots';
import { showClouDNSAds } from '@/common/dateTime';
import ResponsiveNitroPayAd from '@/components/ads/ResponsiveNitroPayAd.vue';
import ClouDNSAd from '@/components/ads/ClouDNSAd.vue';

const props = defineProps({
  config: {
    type: Object as PropType<AdUnit>,
    required: true,
  },
});

// Sold half of the ad slots to ClouDNS
const randomNumber = Math.floor(Math.random() * 100);
const showClouDNS = randomNumber < 50;

function getSizes(size: 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'): string[][] {
  switch (size) {
    case 'default':
      return props.config.default;
    case 'sm':
      return props.config.sm ?? getSizes('default');
    case 'md':
      return props.config.md ?? getSizes('sm');
    case 'lg':
      return props.config.lg ?? getSizes('md');
    case 'xl':
      return props.config.xl ?? getSizes('lg');
    case '2xl':
      return props.config['2xl'] ?? getSizes('xl');
    default:
      return [];
  }
}
</script>
